import { AuthHttp } from 'angular2-jwt';
import { Injectable } from '@angular/core';
import { Http } from '@angular/http';

@Injectable()
export class SponsorService {

  constructor(private http: Http, private authHttp: AuthHttp) { }

  getAllSponsors() {
    return this.http.get("/api/sponsor").map(res => res.json());
  }

  delete(id: number) {
    return this.authHttp.delete("/api/sponsor/" + id).map(res => {
      return { 'status': res.status, 'value': res.json() }
    });
  }

  uploadFile(sponsorId: number, file: any) {
    var formData = new FormData();
    formData.append("file", file);
    // console.log(sponsorId)
    // console.log("FormData");
    // console.log(formData);
    return this.authHttp
      .post(`/api/sponsor/upload/${sponsorId}`, formData)
      .map(res => res.json());
  }

  updateSponsor(sponsor: any) {
    return this.authHttp.put("/api/sponsor/" + sponsor.id, sponsor).map(res => {
      return { 'status': res.status, 'value': res.json() }
    });
  }

  create(sponsor: any) {
    return this.authHttp.post("/api/sponsor", sponsor).map(res => {
      return { 'status': res.status, 'value': res.json() }
    })
  }


}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./ClientApp/app/Services/sponsor.service.ts